import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "\n        card-body\n        p-0\n        d-flex\n        justify-content-between\n        flex-column\n        overflow-hidden\n      " }
const _hoisted_2 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-9 pb-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "Sales"),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400 fw-bold" }, "Oct 8 - Oct 26 21")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", {
          class: ["fw-bolder fs-3", `text-${_ctx.chartColor}`]
        }, "$15,300", 2)
      ]),
      _createVNode(_component_apexchart, {
        class: "mixed-widget-10-chart",
        options: _ctx.chartOptions,
        series: _ctx.series,
        type: "bar",
        height: _ctx.chartHeight
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
}